function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Location");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "All-other-redesigns",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Listing-detail-view-(mover)",
  transform: "translate(-77.000000, -1125.000000)",
  fill: "#FCF6E3",
  stroke: "#EFCEA3",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-block",
  transform: "translate(53.000000, 1106.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location",
  transform: "translate(15.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Custom/Location"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.8274325,31.5414882 C14.4007433,28.271529 11.7013101,25.0279578 10.7291329,21.8107745 C9.7569557,18.5935912 9.7569557,16.1032603 10.7291329,14.3397816 C12.6294272,10.8189657 15.4628181,8.74629486 19.2293057,8.12176902 C24.8790371,7.18498025 29.0980523,11.8062178 29.2005,16.7310114 C29.2288521,18.0939339 28.4721394,21.9484553 26.6080669,24.9839668 C24.1537413,28.9806642 20.3219303,32.1045178 19.2293057,31.694101 C19.1427486,31.661588 19.0087909,31.6107171 18.8274325,31.5414882 Z M19.701266,22.5287421 C21.0819779,22.5287421 23.201266,20.9617387 23.201266,19.0287421 C23.201266,17.0957455 21.0819779,15.5287421 19.701266,15.5287421 C18.3205541,15.5287421 16.201266,16.5957455 16.201266,18.5287421 C16.201266,20.4617387 18.3205541,22.5287421 19.701266,22.5287421 Z",
  id: "Location-"
}))))));

var SvgLocationYellow = function SvgLocationYellow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "26px",
    viewBox: "0 0 21 26",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-yellow.b60a7895.svg";
export { ForwardRef as ReactComponent };